import React, { useState, useRef, useEffect } from "react";
import { Card, Input, Label, Table } from "reactstrap";
import { Plus, PlusCircle, Search, SearchIcon } from "lucide-react";
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { useTranslation } from "react-i18next";
import CommonTable from "../CommonTable";
import { Link, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { useLoader } from "../../_helper/LoaderContext";
import { deleteDoctor, getDoctorList, statusDoctor } from "./service/doctor-service";
import { toast } from "react-toastify";
import MyPagination from "../pagination";
import { Tooltip } from "react-tooltip";
import { useCurrency } from "../../_helper/currencyContext";
import DoctorPayment from "./DoctorPayment";
import { useLab } from "../../_helper/PharmacyProvider";
import { FormLabel } from "react-bootstrap";


export default function DoctorHome() {
    const { t } = useTranslation();
    const [show, setShow] = useState(false);
    const [doctor, setDoctor] = useState(false);
    const [users, setUsers] = useState([]);
    const [search, setSearch] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const [entriesPerPage, setEntriesPerPage] = useState(10);
    const [totalEntries, setTotalEntries] = useState(0);
    const { setLoading } = useLoader();
    const navigate = useNavigate();
    const { getCurrencySymbol } = useCurrency()
    const { currentLab } = useLab()

    useEffect(() => {
        getList()
    }, [currentPage, entriesPerPage, search])

    const getList = async () => {
        setLoading(true)
        try {
            const form_data = new FormData()
            form_data.append("search", search);
            form_data.append("page", currentPage);
            form_data.append("limit", entriesPerPage);
            const res = await getDoctorList(form_data)
            if (res.data.success == true) {
                const filterData = res.data.data.data.map((item) => ({
                    name: item.fname + " " + item.lname,
                    fname: item.fname,
                    lname: item.lname,
                    email: item.email,
                    mobileNumber: item.mobileNumber,
                    hospitalName: item.hospitalName,
                    degree: item.degree,
                    address: item.address,
                    commissionPercent: item.commissionPercent,
                    profileImage: item.profileImage,
                    signatureName: item.signatureName,
                    signature: item.signature || item.signatureImage,
                    _id: item._id,
                    isActive: item.isActive,
                    commissionAmount: item.commissionAmount,
                    paidCommission: item.paidCommission,
                    isClinicDoctor: item.isClinicDoctor === true
                }))
                setUsers(filterData)
                setTotalEntries(res.data.data.totalCount || 0);
            }
        } catch (error) {
            console.log(error)
        } finally {
            setLoading(false)
        }
    }

    const totalPages = Math.ceil(totalEntries / entriesPerPage);

    const handleToggleStatus = (data) => {
        Swal.fire({
            title: "Are you sure?",
            text: data.isActive
                ? "You want to inactivate this doctor?"
                : "You want to activate this doctor?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: `${data.isActive == true ? "Inactive" : "Active"}`
        }).then(async (result) => {
            if (result.isConfirmed) {
                setLoading(true)
                try {
                    const payload = data.isClinicDoctor ? { isClinicDoctor: true } : {};
                    const res = await statusDoctor(data._id, payload)
                    if (res.data.success == true) {
                        toast.success(res.data.message)
                        getList()
                    }
                } catch (error) {
                    console.log(error)
                } finally {
                    setLoading(false)
                }
            }
        });
    };

    const edit = (data) => {
        if (data.isClinicDoctor) {
            sessionStorage.setItem(`clinic-doctor-${data._id}`, JSON.stringify(data));
        }
        navigate(`${process.env.PUBLIC_URL}/edit-doctor/${data._id}${data.isClinicDoctor ? "?isClinicDoctor=true" : ""}`, {
            state: {
                isClinicDoctor: data.isClinicDoctor === true,
                doctor: data.isClinicDoctor ? data : null,
            },
        })
    }

    const detele = (data) => {
        Swal.fire({
            title: "Are you sure?",
            text: "You want to delete this doctor?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: `Yes, delete it!`
        }).then(async (result) => {
            if (result.isConfirmed) {
                setLoading(true)
                try {
                    const payload = data.isClinicDoctor ? { isClinicDoctor: true } : {};
                    const res = await deleteDoctor(data._id, payload)
                    if (res.data.success == true) {
                        toast.success(res.data.message)
                        getList()
                    }
                } catch (error) {
                    console.log(error)
                } finally {
                    setLoading(false)
                }
            }
        });
    };

    const paymentModel = (data) => {
        setShow(true);
        setDoctor(data)
    }

    useEffect(() => {
        const delayDebounce = setTimeout(() => {
            getList();
        }, 500); // waits 0.5s after typing stops

        return () => clearTimeout(delayDebounce);
    }, [search, currentPage, entriesPerPage]);

    const handlePageSizeChange = (e) => {
        const newSize = Number(e.target.value);
        setEntriesPerPage(newSize);  // Use the correct setter
        setCurrentPage(1);           // Reset to page 1
    }

    const getStartingSerialNumber = () => {
        return (currentPage - 1) * entriesPerPage + 1;
    };

    return (
        <>
            <Card>
                <div className="px-3 mt-4">
                    <div className="row">
                        <div className="col-md-6">
                            <div className="input-group mb-3 ">
                                <span className="input-group-text tw-bg-white" id="basic-addon1"><SearchIcon /></span>
                                <input type="text" className="form-control icon_form" placeholder="Search By Name / Email / Mobile" aria-label="Username" aria-describedby="basic-addon1" style={{ borderLeft: 'none' }}
                                    value={search} onChange={(e) => setSearch(e.target.value)} />
                            </div>

                        </div>
                        <div className="col-md-6 text-end">
                            <Link to={`${process.env.PUBLIC_URL}/add-doctors`}>
                                <button className="btn btn-primary">
                                    {t("Add")}
                                </button>
                            </Link>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12">
                            <div className="recent-table table-responsive currency-table tw-rounded-lg tw-border tw-border-black"
                            >
                                <Table className="mb-0 table-center table-bordered table-hover" style={{ tableLayout: "fixed", overflowX: 'auto' }}>
                                    <thead>
                                        <tr>
                                            <th className="text-center bg-primary tw-text-center" style={{
                                                width: "50px"   // 👈 add width only to first column
                                            }}>
                                                <b>#</b>
                                            </th>
                                            <th className="bg-primary text-white text-left" style={{ width: '150px' }}><b>Name</b></th>
                                            {/* <th className="bg-primary text-white text-left" style={{ width: '180px' }}><b>Email</b></th> */}
                                            <th className="bg-primary text-white" style={{ width: '150px' }}><b>Contact</b></th>
                                            <th className="bg-primary text-white" style={{ width: '100px' }}><b>Paid</b></th>
                                            <th className="bg-primary text-white" style={{ width: '100px' }}><b>Balance</b></th>
                                            <th className="bg-primary text-white" style={{ width: '150px' }}><b>Hospital</b></th>
                                            <th className="bg-primary text-white" style={{ width: '100px' }}><b>Status</b></th>
                                            <th className="bg-primary text-white text-center" style={{ width: '180px' }}><b>Action</b></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {users.length > 0 ? (
                                            users.map((item, index) => {
                                                const serialNumber = getStartingSerialNumber() + index;
                                                return (
                                                    <tr key={item.id} className={index % 2 === 0 ? '' : ''}>
                                                        <td className="text-center font-weight-bold">
                                                            {serialNumber}
                                                        </td>
                                                        <td className="tw-px-3 tw-py-3" style={{ overflow: "visible" }}>
                                                            {/* <div
                                                                className="tw-font-medium tw-text-gray-900 tw-ps-3"
                                                                 data-tooltip-id="name-tooltip"
                                                                data-tooltip-content={item.name}
                                                            >
                                                            </div>
                                                            {item.name}
                                                            <Tooltip id="name-tooltip" place="top"/> */}
                                                            <div
                                                                className="tw-ps-3"
                                                                style={{ display: "flex", alignItems: "flex-start", gap: "4px", minWidth: 0 }}
                                                            >
                                                                <span
                                                                    className="tw-font-medium tw-text-gray-900"
                                                                    style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", minWidth: 0, lineHeight: "1.4", paddingTop: "1px" }}
                                                                    data-tooltip-id={`cname-tooltip-${item._id}`}
                                                                    data-tooltip-content={item.name}
                                                                >
                                                                    {item.name}
                                                                </span>
                                                                {item.isClinicDoctor && (
                                                                    <span
                                                                        className="badge rounded-pill"
                                                                        style={{
                                                                            fontSize: "9px",
                                                                            fontWeight: 600,
                                                                            backgroundColor: "#e8eefc",
                                                                            color: "#1e3a8a",
                                                                            padding: "2px 6px",
                                                                            lineHeight: 1.2,
                                                                            flexShrink: 0,
                                                                        }}
                                                                    >
                                                                        Clinic
                                                                    </span>
                                                                )}
                                                            </div>
                                                            <Tooltip id={`cname-tooltip-${item._id}`} place="top" />
                                                        </td>
                                                        {/* <td>
                                                            <div
                                                                className="tw-font-medium tw-text-gray-900 tw-ps-3" style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}
                                                                data-tooltip-id={`cname-tooltip-${item.email}`}
                                                                data-tooltip-content={item.email}
                                                            >
                                                                {item.email}
                                                            </div>
                                                            <Tooltip id={`cname-tooltip-${item.email}`} place="top" />
                                                        </td> */}
                                                        <td>
                                                            {item.mobileNumber}
                                                            <br />
                                                            <small>{item.email}</small>
                                                        </td>
                                                        <td>
                                                            <div className="fw-bold"> {getCurrencySymbol(currentLab?.baseCurrency)}{item.paidCommission?.toFixed(2) || "---"}</div>
                                                        </td>
                                                        <td>
                                                            {getCurrencySymbol(currentLab?.baseCurrency)}{item.commissionAmount?.toFixed(2) || "--"}
                                                        </td>

                                                        <td>
                                                            {item.hospitalName}
                                                        </td>
                                                        <td className="text-center">
                                                            <Label className="switch">
                                                                <Input
                                                                    type="checkbox"
                                                                    checked={item.isActive === true}
                                                                    onChange={() => handleToggleStatus(item)}
                                                                />
                                                                <span className="switch-state"></span>
                                                            </Label>
                                                        </td>

                                                        <td className="tw-px-4 tw-py-4 text-center">
                                                            <div className="">
                                                                {item.commissionAmount > 0 && (
                                                                    <>
                                                                        <Tooltip id="pay" place="top" content="Pay" />
                                                                        <button className='success-action-button me-1' data-tooltip-id="pay" onClick={() => paymentModel(item)}>
                                                                            <i className="fa fa-money" style={{ fontSize: "18px" }}></i>
                                                                        </button>
                                                                    </>
                                                                )}

                                                                <Tooltip id={`edit-${item._id}`} place="top" content="Edit" />
                                                                <button className='success-action-button me-1' data-tooltip-id={`edit-${item._id}`} onClick={() => edit(item)}>
                                                                    <i className="fa fa-pencil-square" style={{ fontSize: "18px" }}></i>
                                                                </button>

                                                                <Link
                                                                    to={`${process.env.PUBLIC_URL}/view-customer/${item._id}`}
                                                                    state={{ isClinicDoctor: item.isClinicDoctor === true }}
                                                                >
                                                                    <Tooltip id={`view-${item._id}`} place="top" content="View" />
                                                                    <button className='success-action-button me-1' data-tooltip-id={`view-${item._id}`}>
                                                                        <i className="fa fa-eye tw-text-red-600" style={{ fontSize: "18px" }}></i>
                                                                    </button>
                                                                </Link>

                                                                {!item.isClinicDoctor && (
                                                                    <>
                                                                        <Tooltip id={`delete-${item._id}`} place="top" content="Delete" />
                                                                        <button className='danger-action-button me-1' data-tooltip-id={`delete-${item._id}`} onClick={() => detele(item)}>
                                                                            <i className="fa fa-trash tw-text-red-600" style={{ fontSize: "18px" }}></i>
                                                                        </button>
                                                                    </>
                                                                )}
                                                            </div>
                                                        </td>
                                                    </tr>
                                                )
                                            }
                                            )
                                        ) : (
                                            <tr>
                                                <td
                                                    colSpan={7}
                                                    className="text-center py-4 text-muted"
                                                >
                                                    No data available
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </Table>
                            </div>
                            <div className="d-md-flex align-items-center text-center justify-content-between mt-3 mb-3">
                                <div className="show-entries">
                                    <FormLabel>Show&nbsp;</FormLabel>
                                    <select style={{ display: 'unset', width: 'auto', padding: '0.375rem 2.25rem 0.375rem 0.75rem' }} value={entriesPerPage}
                                        onChange={handlePageSizeChange} className="form-control">
                                        <option value={5}>5</option>
                                        <option value={10}>10</option>
                                        <option value={30}>30</option>
                                        <option value={20}>20</option>
                                        <option value={50}>50</option>
                                    </select>&nbsp;
                                    <FormLabel>entries</FormLabel>
                                </div>
                                <MyPagination totalPages={totalPages} currentPage={currentPage} onPageChange={(page) => setCurrentPage(page)} />
                            </div>
                            {/* <div className="mt-3">
                                <MyPagination totalPages={totalPages}
                                    currentPage={currentPage}
                                    onPageChange={(page) => setCurrentPage(page)}></MyPagination>
                            </div> */}
                        </div>
                    </div>
                </div>
            </Card>
            <DoctorPayment show={show} onHide={() => setShow(false)} doctor={doctor} getList={getList} />
            {/* <Modal show={show} onHide={handleClose}>
                <AddTestProfile handleClose={handleClose} />
            </Modal> */}
        </>
    )
}
